import { InstOwnFiler, InvestorType } from './constants'

export function getQuarterAndYear(period: string) {
  const year = period.substring(0, 4)
  const quarter = period.substring(4, 6)

  return { quarter, year }
}

type InvestorTitlesOutput = {
  title: string
  subtitle?: string
}

export function getInvestorTitles(filer?: InstOwnFiler | null): InvestorTitlesOutput {
  if (!filer) return { title: '-' }
  const { filerName, otherManagerName, seriesName, portfolioManager } = filer

  switch (filer.investorType) {
    case InvestorType.Fund:
      return {
        title: seriesName ?? filerName ?? '-',
        subtitle: seriesName ? filerName : undefined,
      }
    case InvestorType.Manager:
      return { title: filerName ?? '-', subtitle: portfolioManager }
    case InvestorType.OtherManager:
      return { title: otherManagerName ?? '-', subtitle: portfolioManager }
  }
}
